import { api } from '../../lib/api';

function toQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') q.append(k, v);
  });
  const s = q.toString();
  return s ? `?${s}` : '';
}

export const inventoryApi = {
  stock: (params = {}) => api.get(`/inventory/stock${toQuery(params)}`),
  movements: (params = {}) => api.get(`/inventory/movements${toQuery(params)}`),
};
